//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('workGrp', {
//        templateUrl: 'views/components/views/workGrp/workGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'workGrpService', 'labourPositionService', function ($stateParams, stateService, modalService, translateService, workGrpService, labourPositionService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let workGrpKeyno = $stateParams.workgrp_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                factoryButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') }
//                ],
//                edit: {},
//                selectListFactories: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await workGrpService.getEdit({ workgrp_keyno: workGrpKeyno }))[0];
//            }

//            async function loadSelectFactories() {
//                vm.model.selectListFactories = (await labourPositionService.listSelectFactories());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                workGrpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadSelectFactories();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
